<ui-grid [data]="data$ | async"
         [loading]="loading$ | async">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="main">
            <ng-template>
                <ui-action-expander #actionExpander
                                    *ngLet="isMachinesCreateGranted$ | async as isMachinesCreateGranted"
                                    [tooltipOpen]="'grid_action_add' | translate"
                                    [tooltipClose]="'modal_action_close' | translate"
                                    [disabled]="!isMachinesCreateGranted"
                                    [matTooltip]="isMachinesCreateGranted ? '' : ('authorize_no_permissions' | translate)"
                                    data-cy="machine-add">
                    <button [matTooltip]="'machines_grid_add_standard' | translate"
                            [uiAutofocus]
                            [refocus]="actionExpander?.isActionExpanded$ | async"
                            [uiClickTrack]="'Action: Add: Standard Machine'"
                            (click)="openModal(MachineType.Standard)"
                            mat-mini-fab
                            color="primary"
                            data-cy="machine-add-standard"
                            type="button">
                        <mat-icon svgIcon="uipath:standard-machine"></mat-icon>
                    </button>

                    <button [matTooltip]="'machines_grid_add_template' | translate"
                            [uiClickTrack]="'Action: Add: Machine Template'"
                            (click)="openModal(MachineType.Template)"
                            mat-mini-fab
                            color="primary"
                            data-cy="machine-add-template"
                            type="button">
                        <mat-icon svgIcon="uipath:machine-template"></mat-icon>
                    </button>
                </ui-action-expander>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="action">
            <ng-template>
                <button [disableIf]="loading$ | async"
                        [uiAuthorize]="'Machines.Delete'"
                        [matTooltip]="'machines_grid_action_remove' | translate"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [title]="'machines_grid_name' | translate"
                    [searchable]="true"
                    [sortable]="true"
                    [primary]="true"
                    property="name"
                    sort="asc"
                    width="30%">
    </ui-grid-column>

    <ui-grid-column [title]="'machines_grid_description' | translate"
                    [searchable]="true"
                    property="description"
                    width="30%">
    </ui-grid-column>

    <ui-grid-column [sortable]="true"
                    [title]="'machines_grid_type' | translate"
                    tagPrefix="MachineType_"
                    property="type"
                    width="30%">
        <ui-grid-dropdown-filter [items]="machineList"></ui-grid-dropdown-filter>
        <ng-template let-entry="data">
            <ng-container *ngLet="('MachineType_' + entry.type) | translate as machineTypeText">
                <span [matTooltip]="machineTypeText">{{machineTypeText}}</span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'machines_grid_version' | translate"
                    [primary]="true"
                    property="robotVersions"
                    width="40%">
        <ng-template let-entry="data">
            <ui-machine-robot-versions-display [robotVersions]="entry.robotVersions">
            </ui-machine-robot-versions-display>
        </ng-template>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matMenuTriggerFor]="contextMenu"
                    [uiAuthorizeAny]="['Robots.View', 'Machines.Delete']"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    mat-icon-button
                    data-cy="grid-action-menu"
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #contextMenu="matMenu">
                <button [uiAuthorizeDisable]="'Machines.Edit'"
                        [disabled]="loadingModal$ | async"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        (click)="openModal(MachineType[entry.type], entry)"
                        mat-menu-item
                        data-cy="machine-edit">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    {{ 'machines_grid_action_edit' | translate }}
                </button>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button *ngIf="true"
                        [uiAuthorize]="'Robots.View'"
                        [disableIf]="loading$ | async"
                        [uiAuthorizeDisable]="'Robots.View'"
                        [uiClickTrack]="'Action: Grid: View Installed Versions'"
                        (click)="openVersionsModal(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:robot-versions"></mat-icon>
                    {{ 'machines_grid_action_view_installed_versions' | translate }}
                </button>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button *ngIf="true"
                        [routerLink]="['/user-activity']"
                        [queryParams]="encodeFilters({
                            machineId:  {
                                id: entry.id,
                                text: entry.name
                            }
                        })"
                        [uiAuthorizeAnyDisable]="['Robots.View', 'Users.View']"
                        [disableIf]="loading$ | async"
                        [uiClickTrack]="'Action: Grid: View Robots'"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:robots"></mat-icon>
                    {{ 'machines_grid_action_view_robots' | translate }}
                </button>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button *ngIf="true"
                        [uiAuthorize]="'Machines.Delete'"
                        [disableIf]="loading$ | async"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        data-cy="machine-remove"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    {{ 'machines_grid_remove_tooltip' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
